import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var QuoteSvg = function QuoteSvg() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("path", {
      fill: "#000",
      d: "M6 .75A4.75 4.75 0 0 0 1.25 5.5v5.25H7.5v-1.5H2.75V5.5A3.25 3.25 0 0 1 6 2.25zM9.75 5.5A4.75 4.75 0 0 1 14.5.75v1.5a3.25 3.25 0 0 0-3.25 3.25v3.75H16v1.5H9.75zM8 13.25v1.5h4.75v3.75a3.25 3.25 0 0 1-3.25 3.25v1.5a4.75 4.75 0 0 0 4.75-4.75v-5.25zM16.5 13.25v1.5h4.75v3.75A3.25 3.25 0 0 1 18 21.75v1.5a4.75 4.75 0 0 0 4.75-4.75v-5.25z"
    })
  });
};
export var Quote = function Quote(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: QuoteSvg
  }));
};